module.exports = __webpack_public_path__ + "static/media/pasamosagosto1.fa9b7d07.webp";